exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-all-games-js": () => import("./../../../src/templates/all-games.js" /* webpackChunkName: "component---src-templates-all-games-js" */),
  "component---src-templates-category-js": () => import("./../../../src/templates/category.js" /* webpackChunkName: "component---src-templates-category-js" */),
  "component---src-templates-single-game-js": () => import("./../../../src/templates/single-game.js" /* webpackChunkName: "component---src-templates-single-game-js" */)
}

